/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".repeat-section-container[_ngcontent-%COMP%]{border:3px dashed #ececec;padding:25px}.repeat-section-container[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin-bottom:25px}"];
export { styles as styles };
